import { createContext } from 'react';
import type { IFormStateContext } from './formSateProvider.types';

export const FormStateContext = createContext<IFormStateContext>({
  isFormValid: false,
  setIsFormValid: null,
});
